// extracted by mini-css-extract-plugin
module.exports = {"options_container":"MultipleChoiceType_options_container__3fy1a"};